import { OxySelectorsRevision, OxySelectorsRevisionV } from "@/types/revisions";
import * as t from "io-ts";
import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { mapLeft, toUnion } from "fp-ts/Either";

export async function fetchRemoteOxySelectorsRevisions(): Promise<
  OxySelectorsRevision[] | null
> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_retrieve_oxy_selectors_revisions",
      decoder: t.array(OxySelectorsRevisionV)
    }),
    mapLeft(() => null),
    toUnion
  );
}
